// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"da795cbf","787":"18caff29"}[chunkId] + ".chunk.js";
};